/**
 * Centralized API Configuration
 *
 * This file centralizes the API base URL so it can be easily changed
 * for different environments (development, production, etc.)
 *
 * Usage in components:
 *   import { API_BASE_URL } from '@/config/api'
 *   axios.get(`${API_BASE_URL}/some-endpoint`)
 *
 * Resolution order (first match wins):
 *   1. `VUE_APP_API_BASE_URL` from the environment at *build* time
 *      (Vue CLI inlines this constant into the bundle).
 *      - Empty string ('') means "use relative URLs", which is what we want
 *        in production behind Nginx.
 *      - A non-empty absolute URL is honoured verbatim (useful for staging).
 *   2. When the variable is unset, use relative URLs. Production sends them
 *      through Nginx; Vue's development server proxies them to Flask on
 *      `127.0.0.1:7000`.
 *
 * The `.env.production` file in this folder pins (1) to '' for prod builds,
 * so the safety net in (2) should rarely be needed — but it exists.
 */

const envValue = process.env.VUE_APP_API_BASE_URL;
export const API_BASE_URL = envValue !== undefined ? envValue : '';

export default API_BASE_URL;
